import { render, staticRenderFns } from "./MainViewLayout.vue?vue&type=template&id=c57fa5d8&scoped=true"
import script from "./MainViewLayout.vue?vue&type=script&lang=js"
export * from "./MainViewLayout.vue?vue&type=script&lang=js"
import style0 from "./MainViewLayout.vue?vue&type=style&index=0&id=c57fa5d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57fa5d8",
  null
  
)

export default component.exports